import React from 'react'
import { Box, Card, CardHeader, Grid, Typography, generateUtilityClasses } from '@mui/material'
import { styled } from '@mui/system'
import { BalanceData } from '../../../../../models'
import { formatNumber } from '../../../../../utils/general'

const classes = generateUtilityClasses('Grid', [
  'root',
  'title',
  'titleContainer',
  'leftItemTypography',
  'rightItemTypography',
  'rightItemContainer',
  'leftItemContainer',
])

const StyledGrid = styled(Grid)(() => ({
  [`&.${classes.root}`]: {},

  [`& .${classes.titleContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  [`& .${classes.title}`]: {
    textAlign: 'center',
  },
  [`& .${classes.leftItemContainer}`]: {
    width: '45%',
  },
  [`& .${classes.rightItemContainer}`]: {
    width: '45%',
    marginLeft: '15px',
  },

  [`& .${classes.leftItemTypography}`]: {
    textAlign: 'right',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
  },
  [`& .${classes.rightItemTypography}`]: {
    textAlign: 'left',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
  },
}))

interface Props {
  balancesData: BalanceData[]
}

const BalancesCard = ({ balancesData }: Props) => {
  return (
    <Card>
      <CardHeader title='Balances' />
      <Box sx={{ p: 3 }} display={'flex'} flexDirection={'column'}>
        {balancesData?.map(
          (el) =>
            el?.Amount && (
              <Box display={'flex'} alignItems={'baseline'}>
                <Typography sx={{ py: 1 }} variant='body2'>
                  {el?.Name} :
                </Typography>

                <Typography sx={{ ml: 1, py: 1 }} variant='body2'>
                  {formatNumber(el?.Amount)}
                </Typography>
              </Box>
            ),
        )}
      </Box>
    </Card>
  )
}

export default BalancesCard
